import store from '../reducers'
import {PageActions} from 'actions'
import events from 'actions/events'

export default () => {
    events.on('Filters.componentDidSubmit',()=>{
        PageActions.navToTimeSlots()
    })

    events.on('TimeSlots.componentDidSubmit',()=>{
        PageActions.navToCollectInformation()
    })

    events.on('CollectInformation.componentDidSubmit',()=>{
        PageActions.navToConfirmation()
    })

    events.on('Confirmation.componentDidSubmit',()=>{
        PageActions.navToReceipt()
    })
}


// WEBPACK FOOTER //
// ./eventFlows/defaultFlows.js